module.exports = __webpack_public_path__ + "img/books.7b5e7149.svg";